import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import { formatCurrency } from '../../../lib/helpers/formatters';
import { useAuth } from '../../../commons/Auth';

function Summary({ totals = {}, profileType }) {
  const [t] = useTranslation('CONTACTS');
  const [{ newIsAdmin }] = useAuth();

  const {
    variableRevenuesSubAdmins = 0,
    billableVariableRevenuesSubAdmins = 0,
    variableRevenues = 0,
    billableVariableRevenues = 0,
    variableRevenuesInsurance = 0,
    billableVariableRevenuesInsurance = 0,
    variableRevenuesSignals = 0,
    billableVariableRevenuesSignals = 0,
    variableRevenuesEnergy = 0,
    billableVariableRevenuesEnergy = 0,
    variableRevenuesRecurrentEnergy = 0,
    billableVariableRevenuesRecurrentEnergy = 0,
    totalNet = 0,
    billableTotalNet = 0,
    bonuses = 0,
    lastYearMasterContractAmount = 0,
    lastYearRevenue = 0,
    total = 0,
    billableTotal = 0,
  } = totals;

  return (
    <div className="summary-table">
      {/* TABLE HEADING */}
      <Row className="heading-row">
        <Col xs="4"></Col>
        <Col xs="4">
          <p>{t('EARNED_SHARE')}</p>
        </Col>
        <Col xs="4">
          <p>{t('BILLABLE_SHARE')}</p>
        </Col>
      </Row>

      {/* COMPENSI FATTURE SOTTOPOSTI */}
      {['BUILDING_ADMIN_5'].includes(profileType) && (
        <Row className="normal-row">
          <Col xs="4">
            <p>{t('FINANCIAL_REPORT_TOTAL8')}</p>
          </Col>
          <Col xs="4">
            <p>{formatCurrency(variableRevenuesSubAdmins)}</p>
          </Col>
          <Col xs="4">
            <p>{formatCurrency(billableVariableRevenuesSubAdmins)}</p>
          </Col>
        </Row>
      )}

      {!['SUPPLIER', 'EON_ENERGY'].includes(profileType) && (
        <>
          {/* COMPENSI FATTURE FORNITORE */}
          <Row className="normal-row">
            <Col xs="4">
              <p>{t('FINANCIAL_REPORT_TOTAL6')}</p>
            </Col>
            <Col xs="4">
              <p>{formatCurrency(variableRevenues)}</p>
            </Col>
            <Col xs="4">
              <p>{formatCurrency(billableVariableRevenues)}</p>
            </Col>
          </Row>

          {/* COMPENSI ENERGIA */}
          <Row className="normal-row">
            <Col xs="4">
              <p>{t('FINANCIAL_REPORT_TOTAL9')}</p>
            </Col>
            <Col xs="4">
              <p>{formatCurrency(variableRevenuesEnergy)}</p>
            </Col>
            <Col xs="4">
              <p>{formatCurrency(billableVariableRevenuesEnergy)}</p>
            </Col>
          </Row>

          {/* COMPENSI ENERGIA */}
          <Row className="normal-row">
            <Col xs="4">
              <p>{t('FINANCIAL_REPORT_TOTAL10')}</p>
            </Col>
            <Col xs="4">
              <p>{formatCurrency(variableRevenuesRecurrentEnergy)}</p>
            </Col>
            <Col xs="4">
              <p>{formatCurrency(billableVariableRevenuesRecurrentEnergy)}</p>
            </Col>
          </Row>

          {/* COMPENSI ASSICURAZIONI */}
          {newIsAdmin && (
            <Row className="normal-row">
              <Col xs="4">
                <p>{t('FINANCIAL_REPORT_TOTAL7')}</p>
              </Col>
              <Col xs="4">
                <p>{formatCurrency(variableRevenuesInsurance)}</p>
              </Col>
              <Col xs="4">
                <p>{formatCurrency(billableVariableRevenuesInsurance)}</p>
              </Col>
            </Row>
          )}
        </>
      )}

      {/* COMPENSI SEGNALAZIONI */}
      <Row className="normal-row">
        <Col xs="4">
          <p>{t('FINANCIAL_REPORT_TOTAL11')}</p>
        </Col>
        <Col xs="4">
          <p>{formatCurrency(variableRevenuesSignals)}</p>
        </Col>
        <Col xs="4">
          <p>{formatCurrency(billableVariableRevenuesSignals)}</p>
        </Col>
      </Row>

      {/* IMPONIBILE NETTO */}
      <Row className="highlighted-row">
        <Col xs="4">
          <p>{t('FINANCIAL_REPORT_TOTAL3')}</p>
        </Col>
        <Col xs="4">
          <p>{formatCurrency(totalNet)}</p>
        </Col>
        <Col xs="4">
          <p>{formatCurrency(billableTotalNet)}</p>
        </Col>
      </Row>

      {/* SALDO ANNO PRECEDENTE */}
      <Row className="highlighted-row">
        <Col xs="4">
          <p>{t('FINANCIAL_REPORT_TOTAL4')}</p>
        </Col>
        <Col xs="4">
          <p>{formatCurrency(lastYearMasterContractAmount)}</p>
        </Col>
        <Col xs="4">
          <p>{formatCurrency(lastYearRevenue)}</p>
        </Col>
      </Row>

      {/* INVITI A FATTURARE */}
      <Row className="highlighted-row">
        <Col xs="4" className="flex-between">
          <p>{t('CONTACTS:LABEL_INVOICE_BONUS')}</p>
        </Col>
        <Col xs="4">
          <p>{formatCurrency(bonuses)}</p>
        </Col>
        <Col xs="4">
          <p>{formatCurrency(bonuses)}</p>
        </Col>
      </Row>

      {/* SALDO */}
      <Row className="highlighted-row">
        <Col xs="4">
          <p>{t('FINANCIAL_REPORT_TOTAL5')}</p>
        </Col>
        <Col xs="4">
          <p>{formatCurrency(total)}</p>
        </Col>
        <Col xs="4">
          <p>{formatCurrency(billableTotal)}</p>
        </Col>
      </Row>
    </div>
  );
}

export default withRouter(Summary);
